module.exports = __webpack_public_path__ + "static/media/Blipbla-pantalla-1.911e209f.jpg";